import template from './valuebar.html'

let component = {
	bindings: {
		relative: '=',
		value: "=", 
		inverse: "=",
		display: "="
	},
	template: template,
	controller: function(){
		
		var vm = this;

		vm.barColor = vm.relative;

		if(vm.inverse){
			vm.barColor = 1 - vm.relative;
		}			
	}
}

export default component;


// WEBPACK FOOTER //
// ./app/components/valuebar/valuebar.component.js